import { useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Flex,
    IconVerifiedUser,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

export const TrustedByLink = () => {
    const [opened, { toggle }] = useDisclosure(false);
    const { t } = useTranslation();

    return (
        <>
            <Flex align="center" justify="center" gap="xxs">
                <IconVerifiedUser filled color="primary" />
                <Anchor
                    textAlign="center"
                    textDecoration="underline"
                    onClick={toggle}
                >
                    {t('signUpPage.lilly.trustedBy.link')}
                </Anchor>
            </Flex>

            <Modal
                opened={opened}
                title={t('signUpPage.lilly.trustedBy.modal.title')}
                onClose={toggle}
                size="lg"
            >
                <Stack gap="md">
                    <Body1>{t('signUpPage.lilly.trustedBy.modal.body1')}</Body1>
                    <Body1>{t('signUpPage.lilly.trustedBy.modal.body2')}</Body1>
                    <Body1>{t('signUpPage.lilly.trustedBy.modal.body3')}</Body1>
                </Stack>
            </Modal>
        </>
    );
};
